/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RemovePlaidAccountInput = {|
  clientMutationId?: ?string,
  integrationItemId: string,
|};
export type removePlaidAccountMutationVariables = {|
  input: RemovePlaidAccountInput
|};
export type removePlaidAccountMutationResponse = {|
  +removePlaidAccount: ?{|
    +errorMessage: ?string,
    +successMessage: ?string,
  |}
|};
export type removePlaidAccountMutation = {|
  variables: removePlaidAccountMutationVariables,
  response: removePlaidAccountMutationResponse,
|};
*/


/*
mutation removePlaidAccountMutation(
  $input: RemovePlaidAccountInput!
) {
  removePlaidAccount(input: $input) {
    errorMessage
    successMessage
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "RemovePlaidAccountInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemovePlaidAccountPayload",
    "kind": "LinkedField",
    "name": "removePlaidAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "removePlaidAccountMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "removePlaidAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "removePlaidAccountMutation",
    "operationKind": "mutation",
    "text": "mutation removePlaidAccountMutation(\n  $input: RemovePlaidAccountInput!\n) {\n  removePlaidAccount(input: $input) {\n    errorMessage\n    successMessage\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dedb6de9d79f0dfa5b545d4640514002';

module.exports = node;
